import styled from 'styled-components';
import { BasketMandatoryFeesStyled } from '../BasketMandatoryFeesStyled';

export const BasketMandatoryFeesDetailsAP = styled(BasketMandatoryFeesStyled)``;